import React, { useState, createContext } from 'react';
import ls from 'local-storage';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [emailLinked, setEmailLinked] = useState(false);
    const onSetCurrentUser = userData => {
        setCurrentUser(userData);
        if (userData !== null) {
            ls('go_parent_user', JSON.stringify(userData));
        }
    }

    return (
        <AuthContext.Provider
            value={{
                currentUser,
                emailLinked,
                setEmailLinked,
                setCurrentUser: onSetCurrentUser
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}